import React from 'react';

const FinancialReportsPage = () => {
    return (
        <div>
            
        </div>
    );
}

export default FinancialReportsPage;
